/**
 * Product mark: a geometric Y on a theme-aware tile.
 *
 * The Y is the letter people say as «игрик»; the fork also reads as a board
 * pin / cursor branching into space — enough identity without spelling it out.
 */
export function BrandMark({ size = 26 }: { size?: number }) {
  return (
    <svg
      className="brand-mark"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="32" height="32" rx="9" fill="var(--brand-mark-bg, #111827)" />
      <path
        d="M9.2 8.5 L16 17.2 L22.8 8.5 M16 17.2 V24.2"
        fill="none"
        stroke="var(--brand-mark-fg, #fff)"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BrandLogo({
  compact = false,
  className = '',
  markSize,
}: {
  /** Hide the “Board” word on very tight chrome. */
  compact?: boolean;
  className?: string;
  markSize?: number;
}) {
  return (
    <div className={`brand ${className}`.trim()} aria-label="Ygrik Board">
      <BrandMark size={markSize} />
      <span className="brand-wordmark">
        <span className="brand-name">Ygrik</span>
        {!compact && <span className="brand-product">Board</span>}
      </span>
    </div>
  );
}
